import React, {Component} from 'react';

import wm_number from '../../assets/sounds/de/pauses/FOL-C-006.mp3';
import wm_trial_sound from '../../assets/sounds/de/pauses/SCR-A-007.mp3';
import wmN_trial_child_sound from '../../assets/sounds/de/pauses/SCR007-child.mp3';
import wmW_trial_child_sound from '../../assets/sounds/de/pauses/SCR007-child.mp3';
import wmN_trial_adult_sound from '../../assets/sounds/de/pauses/FOL-A-006.flac';
import wmW_trial_adult_sound from '../../assets/sounds/de/pauses/FOL-A-010.flac';

import wm_words from '../../assets/sounds/de/pauses/FOL-C-013.mp3';
import ranChild from '../../assets/sounds/de/pauses/rapidnaming.mp3';
import ranAdult from '../../assets/sounds/de/pauses/FOL-A-020.flac';

import Onemint from '../../assets/sounds/de/pauses/FOL047.wav';
import OnemintChild from '../../assets/sounds/de/pauses/minChild.mp3';
import OnemintAdult from '../../assets/sounds/de/pauses/FOL-A-022.flac';

import spoonerism from '../../assets/sounds/de/pauses/FOL072.wav';
import spoonerismAdult from '../../assets/sounds/de/pauses/FOL-A-047.flac';

import phonemedeletionSound from '../../assets/sounds/de/pauses/pd-finish-sound.mp3';
import nonWordSound from '../../assets/sounds/de/pauses/FOL-A-082.flac';
import sentenceMemorySound from '../../assets/sounds/de/pauses/FOL-A-107.flac';

import AudioPlayer from '../../components/AudioPlayer';
import strings from '../../strings';

class Pause extends Component {
	constructor(props) {
		super(props);

		this.wm_number_sound = wm_number;
		this.wm_words_sound = wm_words;
		this.wm_number_child_sound = wm_number; //For child followupo
		this.wm_words_child_sound = wm_words; //For child followupo
		this.ran_sound = ranChild;
		this.Onemint_sound = Onemint;
		this.Onemint_soundChild = OnemintChild;
		this.spoonerism_sound = spoonerism;
		this.pd_sound = phonemedeletionSound;
		this.nw_sound = nonWordSound;
		this.sm_sound = sentenceMemorySound;

		this.state = {
			testName: this.props.testName ? this.props.testName : '',
			displayBtn: true,
		};
	}

	returnRelevantSound(testName) {
		const {testKeyType, pauseSound} = this.props;

		const isChildFollowup = testKeyType === 'child-followup';
		const isAdultFollowup = testKeyType === 'adult-followup';

		const isTrial = pauseSound === 'trial';

		switch (testName) {
			case strings.wsn_testname:
			case strings.wsn_testname_adult: {
				if (isTrial) {
					return isChildFollowup
						? wmN_trial_child_sound
						: wm_trial_sound;
				} else if (isAdultFollowup) {
					return wmN_trial_adult_sound;
				}
				return this.wm_number_sound;
			}

			case strings.wsw_testname:
			case strings.wsw_testname_adult: {
				if (isTrial) {
					return isChildFollowup
						? wmW_trial_child_sound
						: wm_trial_sound;
				} else if (isAdultFollowup) {
					return wmW_trial_adult_sound;
				}
				return this.wm_words_sound;
			}

			case strings.rn_testname:
				return isAdultFollowup ? ranAdult : this.ran_sound;

			case strings.om_testname:
			case strings.om_testname_adult:
				return isAdultFollowup ? OnemintAdult : this.Onemint_soundChild;

			case strings.sp_testname:
			case strings.sp_testnameAdult:
				return isAdultFollowup
					? spoonerismAdult
					: this.spoonerism_sound;

			case strings.pd_child_testname:
				return this.pd_sound;
			case strings.nw_testName:
				return this.nw_sound;
			case strings.sm_testname:
				return this.sm_sound;

			default:
				return null;
		}
	}

	render() {
		const {testName, displayBtn} = this.state;
		const {testKeyType, pauseSound} = this.props;

		const isAdultFollowup = testKeyType === 'adult-followup';
		const isChildFollowup = testKeyType === 'child-followup';

		const isAdultRapidNaming =
			isAdultFollowup && testName === strings.rn_testname;

		const isAdultOneMinute =
			isAdultFollowup && testName === strings.om_testname_adult;

		const isAdultSpoonerism =
			isAdultFollowup && testName === strings.sp_testnameAdult;
		const isAdultNonWord =
			isAdultFollowup && testName === strings.nw_testName;
		const isAdultSentenceMemory =
			isAdultFollowup && testName === strings.sm_testName;
		const isGerman = strings.getLanguage() === 'de';

		let message;

		if (pauseSound !== 'trial') {
			let pauseText;

			if (isAdultRapidNaming) {
				pauseText = strings.testDoneAdult;
			} else if (isAdultOneMinute) {
				pauseText = strings.testDoneAdult3;
			} else if (
				isAdultSpoonerism ||
				isAdultNonWord ||
				isAdultSentenceMemory
			) {
				pauseText = strings.testDoneAdult4;
			} else if (isAdultFollowup) {
				pauseText = strings.testDoneAdult2;
			} else {
				pauseText = strings.pauseBeforeNextTest;
			}

			message = strings.formatString(pauseText, testName);
		} else if (isAdultFollowup) {
			message = strings.trialIsNowOverAdult;
		} else if (!isChildFollowup) {
			message = strings.trialIsNowOver;
		} else {
			message = `Jetzt hast Du die drei Beispiele gelöst und es geht mit den richtigen Aufgaben weiter. Deine Lehrkraft darf dir nun nicht mehr helfen. Klicke auf „Los“, um mit der Aufgabe zu beginnen. `;
		}

		return (
			<div>
				<p>
					{testName && isGerman && (
						<AudioPlayer
							autoplay
							inline
							src={this.returnRelevantSound(testName)}
						/>
					)}

					{message}
				</p>

				{pauseSound === 'trial' && displayBtn && (
					<div>
						<button
							onClick={() => this.setState({displayBtn: false})}
						>
							{isAdultFollowup
								? strings.startAdult
								: strings.start}
						</button>
					</div>
				)}
			</div>
		);
	}
}

export default Pause;
